// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
/// <reference path="../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
var Coveo = require("coveo-search-ui");
var EndpointCaller = (function () {
    function EndpointCaller(endpointCaller) {
        this.endpointCaller = endpointCaller || new Coveo.EndpointCaller();
    }
    EndpointCaller.prototype.sendPost = function (url, postData) {
        var callOptions = {
            errorsAsSuccess: false,
            method: "POST",
            queryString: [],
            requestData: postData,
            url: url,
            responseType: "text",
            requestDataType: "application/json"
        };
        return this.endpointCaller.call(callOptions);
    };
    return EndpointCaller;
}());
exports.__esModule = true;
exports["default"] = EndpointCaller;



//////////////////
// WEBPACK FOOTER
// ./Base/EndpointCaller.ts
// module id = 16
// module chunks = 0